export const urls = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about-us" },
  { name: "Utah At A Glance", path: "/utah-at-a-glance" },
  { name: "Utah Key Economic Verticals", path: "/verticals" },
  { name: "Utah Gallery", path: "/gallery" },
  { name: "Search", path: "/search" },
  { name: "Betsy", path: "/search" },
  { name: "Contact Us", path: "/contact-us" },
  { name: "Privacy Policy", path: "/privacy-policy" },
  { name: "FAQ", path: "/faq" },
  { name: "Founder's Note", path: "/founders-note" },
  { name: "Sitemap", path: "/sitemap" },
  { name: "Copyright", path: "/copyright" },
  { name: "Utah Governor", path: "/utah-at-a-glance/utah-governor" },
  {
    name: "Adventure Activities",
    path: "/utah-at-a-glance/adventure-activities",
  },
  { name: "Air Quality Index", path: "/utah-at-a-glance/air-quality-index" },
  { name: "Utah Airports", path: "/utah-at-a-glance/utah-airports" },
  { name: "Autism & DD", path: "/utah-at-a-glance/autism-dd" },
  { name: "Utah Budget", path: "/utah-at-a-glance/utah-budget" },
  { name: "Charging Stations", path: "/utah-at-a-glance/charging-stations" },
  { name: "Utah Cities", path: "/utah-at-a-glance/utah-cities" },
  { name: "Utah Counties", path: "/utah-at-a-glance/utah-counties" },
  {
    name: "Utah County",
    path: "/utah-at-a-glance/utah-counties/utah-county",
  },
  { name: "Demographics", path: "/utah-at-a-glance/demographics" },
  {
    name: "Education And Intellectual Resources",
    path: "/utah-at-a-glance/universities-and-schools",
  },
  { name: "Utah Employment Trends", path: "/utah-at-a-glance/utah-employment" },
  { name: "Federal Agencies", path: "/utah-at-a-glance/federal-agencies" },
  {
    name: "Financial Institution",
    path: "/utah-at-a-glance/financial-institutions",
  },
  {
    name: "Geothermal Hotspots",
    path: "/utah-at-a-glance/utah-geothermal-hotspots",
  },
  {
    name: "Hill Airforce Base",
    path: "/utah-at-a-glance/hill-airforce-base",
  },
  {
    name: "Utah Hospitals",
    path: "/utah-at-a-glance/hospitals",
  },
  {
    name: "Utah Housing",
    path: "/utah-at-a-glance/housing",
  },
  {
    name: "Utah Libraries",
    path: "/utah-at-a-glance/utah-libraries",
  },
  {
    name: "MLM",
    path: "/utah-at-a-glance/mlm",
  },
  {
    name: "Utah Mines",
    path: "/utah-at-a-glance/utah-mines",
  },
  {
    name: "Utah Places To Visit",
    path: "/utah-at-a-glance/utah-places-to-visit",
  },
  {
    name: "Utah Sports Club",
    path: "/utah-at-a-glance/sports-club",
  },
  {
    name: "Utah Taxes",
    path: "/utah-at-a-glance/taxes",
  },
  {
    name: "Utah Water",
    path: "/utah-at-a-glance/utah-water",
  },
  {
    name: "Unemployment Rate Trends",
    path: "/utah-at-a-glance/unemployment-rate",
  },
  {
    name: "Utah Voters Count",
    path: "/utah-at-a-glance/utah-voters-count",
  },
  {
    name: "Utah Zipcodes",
    path: "/utah-at-a-glance/zipcodes",
  },
  {
    name: "Manufacturing",
    path: "/verticals/manufacturing",
  },
  {
    name: "Aerospace & Defense",
    path: "/verticals/aerospace-and-defense",
  },
  {
    name: "Food Industry",
    path: "/verticals/food-industry",
  },
  {
    name: "Professional Scientifc & Technical Services",
    path: "/verticals/professional-scientific-and-technical-services",
  },
  {
    name: "Information",
    path: "/verticals/information",
  },
  {
    name: "Construction",
    path: "/verticals/construction",
  },
  {
    name: "Transportation & Warehousing",
    path: "/verticals/transportation-and-warehousing",
  },
  {
    name: "Mining",
    path: "/verticals/mining",
  },
  {
    name: "Airforce base Economic Impact",
    path: "/verticals/hill-airforce-base-economic-impact",
  },
  {
    name: "Utah Nonprofits",
    path: "/utah-at-a-glance/utah-nonprofits",
  },
  {
    name: "Utah Nonprofit Data Insights",
    path: "/utah-at-a-glance/utah-nonprofits/nonprofit-data-insights",
  },
  {
    name: "Utah Universities",
    path: "/utah-at-a-glance/universities-and-schools/utah-universities",
  },
  {
    name: "Utah Schools",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools",
  },
  {
    name: "Utah Charter Schools",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/charter-schools",
  },
  {
    name: "National Forests",
    path: "/utah-at-a-glance/utah-places-to-visit/national-forests",
  },
  {
    name: "Natonal Wildlife Refuges",
    path: "/utah-at-a-glance/utah-places-to-visit/national-wildlife-refuges",
  },
  {
    name: "National Recreation Area",
    path: "/utah-at-a-glance/utah-places-to-visit/national-recreation-area",
  },
  {
    name: "National Historic Site",
    path: "/utah-at-a-glance/utah-places-to-visit/national-historic-site",
  },
  {
    name: "National Monument",
    path: "/utah-at-a-glance/utah-places-to-visit/national-monument",
  },
  {
    name: "National Forest Services",
    path: "/utah-at-a-glance/utah-places-to-visit/national-forest-services",
  },
  {
    name: "Land Management Wilderness",
    path: "/utah-at-a-glance/utah-places-to-visit/land-management-wilderness",
  },
  {
    name: "Utah National Parks",
    path: "/utah-at-a-glance/utah-places-to-visit/utah-nationalparks",
  },
  {
    name: "Utah State Parks",
    path: "/utah-at-a-glance/utah-places-to-visit/utah-stateparks",
  },
  {
    name: "Support Sponsor Request",
    path: "/support-sponsor-request",
  },
  {
    name: "Supporters And Sponsors",
    path: "/supporters-and-sponsors",
  },
  {
    name: "Schools in Alpine",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/alpine",
  },
  {
    name: "Schools in Beaver",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/beaver",
  },
  {
    name: "Schools in Box Elder",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/boxelder",
  },
  {
    name: "Schools in Cache County",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/cache",
  },
  {
    name: "Schools in Canyons",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/canyons",
  },
  {
    name: "Schools in Carbon",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/carbon",
  },
  {
    name: "Schools in Daggett",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/daggett",
  },
  {
    name: "Schools in Davis",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/davis",
  },
  {
    name: "Schools in Duchesne",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/duchesne",
  },
  {
    name: "Schools in Emery",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/emery",
  },
  {
    name: "Schools in Garfield",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/garfield",
  },
  {
    name: "Schools in Grand County",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/grand",
  },
  {
    name: "Schools in Granite",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/granite",
  },
  {
    name: "Schools in Iron County",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/iron",
  },
  {
    name: "Schools in Jordan",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/jordan",
  },
  {
    name: "Schools in Juab",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/juab",
  },
  {
    name: "Schools in Kane",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/kane",
  },
  {
    name: "Schools in Logan",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/logan",
  },
  {
    name: "Schools in Millard",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/millard",
  },
  {
    name: "Schools in Morgan",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/morgan",
  },
  {
    name: "Schools in Murray",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/murray",
  },
  {
    name: "Schools in Nebo",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/nebo",
  },
  {
    name: "Schools in North Sanpete",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/sanpete",
  },
  {
    name: "Schools in North Summit",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/summit",
  },
  {
    name: "Schools in Ogden",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/ogden",
  },
  {
    name: "Schools in Park City",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/park",
  },
  {
    name: "Schools in Piute",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/piute",
  },
  {
    name: "Schools in Provo City",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/provo",
  },
  {
    name: "Schools in Rich",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/rich",
  },
  {
    name: "Schools in Salt Lake City",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/salt",
  },
  {
    name: "Schools in San Juan",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/san",
  },
  {
    name: "Schools in Sevier",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/sevier",
  },
  {
    name: "Schools in South Sanpete",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/southSanpete",
  },
  {
    name: "Schools in South Summit",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/southSummit",
  },
  {
    name: "Schools in Tintic",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/tintic",
  },
  {
    name: "Schools in Tooele County",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/tooele",
  },
  {
    name: "Schools in Uintah",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/uintah",
  },
  {
    name: "Schools in Wasatch",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/wasatch",
  },
  {
    name: "Schools in Washington County",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/washington",
  },
  {
    name: "Schools in Wayne County",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/wayne",
  },
  {
    name: "Schools in Weber",
    path: "/utah-at-a-glance/universities-and-schools/utah-schools/weber",
  },
];

